import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = "https://qgfynwwwauyfqdaajtcc.supabase.co";
const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFnZnlud3d3YXV5ZnFkYWFqdGNjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzg5NzE4NzQsImV4cCI6MjA1NDU0Nzg3NH0.ePiQpuq2rnPTHYy3G9pEcyx5RFvBv_sadH-HVL6DsJw";

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
